import featureEnabled from 'shared/helper/feature';
import { initMixpanel, trackEvent, identifyUser, resetMixpanel, trackNavbarEventMixpanel } from 'rubriq/helpers/mixpanel';
import initAnalytics, { trackEventRudder, identifyUserRudder, resetRudder, trackNavbarEventRudder } from 'rubriq/helpers/analytics';
var isMixpanelEnabled = 'true';
var isRudderEnabled = function isRudderEnabled() {
  return featureEnabled('rubriq_rudderstack');
};

/**
 * Initialize enabled analytics providers
 */
export var initRubriqAnalytics = function initRubriqAnalytics(_ref) {
  var mixpanelToken = _ref.mixpanelToken,
    rudder = _ref.rudder;
  if (isMixpanelEnabled && mixpanelToken) {
    initMixpanel(mixpanelToken);
  }
  if (isRudderEnabled() && rudder !== null && rudder !== void 0 && rudder.writeKey && rudder !== null && rudder !== void 0 && rudder.dataPlaneUrl) {
    initAnalytics(rudder.writeKey, rudder.dataPlaneUrl);
  }
};

/**
 * Track event across enabled analytics providers
 */
var trackRubriqEvent = function trackRubriqEvent(eventName) {
  var payload = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  if (!eventName) return;
  if (isMixpanelEnabled) {
    trackEvent(eventName, payload);
  }
  if (isRudderEnabled()) {
    trackEventRudder(eventName, payload);
  }
};
export var trackNavbarEvent = function trackNavbarEvent(label, section) {
  var extra = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  if (isMixpanelEnabled) {
    trackNavbarEventMixpanel(label, section, extra);
  }
  if (isRudderEnabled()) {
    trackNavbarEventRudder(label, section, extra);
  }
};

/**
 * Identify user across enabled analytics providers
 */
export var identifyRubriqUser = function identifyRubriqUser(userId) {
  var traits = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  if (!userId) return;
  if (isMixpanelEnabled) {
    identifyUser(userId, traits);
  }
};
/**
 * Reset analytics across enabled providers
 */
export var resetRubriqAnalytics = function resetRubriqAnalytics() {
  if (isMixpanelEnabled) {
    resetMixpanel();
  }
  if (isRudderEnabled()) {
    resetRudder();
  }
};
export default trackRubriqEvent;